var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleModal',{staticClass:"self_proclaim_modal",on:{"close":function($event){return _vm.$emit('close')}}},[_c('RoleList',{attrs:{"game":_vm.game,"player":_vm.player},on:{"proclaim":_vm.proclaimRole}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }